import { useEffect, useRef, useState } from "react";
import { useModalForm } from "../../../../../utils/hooks/useModalForm";
import BulkUploadModal from "../../OfflineLeads/BulkUploadModal";
import ProcessedSearch from "./ProcessedSearch";

const Processed = (props) => {
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const [isFetching, setIsFetching] = useState(true);
  const [search, setSearch] = useState({
    page: 1,
    // limit: 10,
  });
  const [rowcount, setRowcount] = useState(0);
  const [applId, setApplId] = useState(null);
  const [data, setData] = useState([]);
  // ----------------------------------------------------------------
  const columns = [
    {
      dataIndex: "created_by",
      title: "Connector Name",
      render: (text, record) => {
        return (
          <span className="table-primary-text">
            {record?.created_by?.full_name}
          </span>
        );
      },
      display: isAdmin ? true : false,
    },
    {
      dataIndex: "created_by",
      title: "Connector Mobile No.",
      render: (text, record) => {
        return (
          <span className="table-primary-text">
            {record?.created_by?.mobile_number}
          </span>
        );
      },
      display: isAdmin ? true : false,
    },
    {
      dataIndex: "borrower_full_name",
      title: "Customer Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "borrower_mobile_number",
      title: "Customer Mobile No.",
      render: (text, record) => {
        return <span className="table-primary-text">{text}</span>;
      },
    },
    {
      dataIndex: "application_number",
      title: "Application No.",
    },
    {
      dataIndex: "created_by",
      title: "Bank Name",
      render: (text, record) => {
        let bankName =
          record?.created_by?.bank_details?.bank_account_holder_bank_name;
        return <>{bankName || "-"}</>;
      },
    },
    {
      dataIndex: "loan_disbursed_amount",
      title: "Disb. Amt.",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "loan_disbursement_date",
      title: "Disb. Date",
      render: (text, record) => {
        if (record?.loan_disbursement_date) {
          let date = new Date(text).dateToDDMMYYYY(new Date(text));
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "connector_payout_status",
      title: "Payment Status",
      render: (text, record) => {
        let status = record?.application_payout?.connector_payout_status;
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[status.toLowerCase()]}>
            {status?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
  ];

  // ----------------------------------------------------------------
  // ROW SELECTION
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [notSelected, setNotSelected] = useState(true);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => {
      if (record?.paymentStatus === "PROCESSED") {
        return { disabled: false };
      } else {
        return { disabled: true };
      }
    },
  };
  // ----------------------------------------------------------------

  // APPLICATION LOAN
  const modalConfigs = {
    applicationLoan: [
      {
        name: "borrower_full_name",
        label: "Customer Name",
        type: "text",
        required: true,
      },
      {
        name: "borrower_mobile_number",
        label: "Mobile No.",
        type: "text",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
      },
      {
        name: "application_product_type",
        label: "Product Type",
        type: "select",
        fetchOptions: () => props.apis.apiGetProductTypes(),
        required: true,
      },
      {
        name: "lender_bank_name",
        label: "Bank Name",
        type: "select",
        options: [],
        fetchOptions: () => props.apis.apiGetBanknames(),
        required: true,
      },
      {
        name: "application_number",
        label: "Application No.",
        type: "text",
        required: true,
      },
      {
        name: "application_status",
        label: "Application Status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
        disabled: true,
      },
      {
        name: "loan_disbursed_amount",
        label: "Disb. Amount",
        type: "number",
        required: true,
      },
      {
        name: "loan_disbursement_date",
        label: "Disb. Date",
        type: "date",
        required: true,
      },
    ],
    payoutInfo: [
      {
        type: "section",
        label: "Loan Info:",
        divider: false,
        colspan: 24,
        align: "end",
      },
      { type: "empty", colspan: 24 },
      {
        name: "borrower_full_name",
        label: "Connector Name",
        type: "text",
        readOnly: true,
      },
      {
        name: "borrower_mobile_number",
        label: "Connector Mobile No.",
        type: "text",
        readOnly: true,
      },
      {
        name: "customer_name",
        label: "Customer Name",
        type: "text",
        readOnly: true,
      },
      {
        name: "mobile_number",
        label: "Mobile No.",
        type: "text",
        readOnly: true,
      },
      {
        name: "application_product_type",
        label: "Product Type",
        type: "select",
        options: _enum.LOAN_TYPES,
        readOnly: true,
      },
      {
        name: "lender_bank_name",
        label: "Bank Name",
        type: "select",
        options: [{ key: "SBI", label: "SBI" }],
        readOnly: true,
      },
      {
        name: "loan_amount",
        label: "Loan Amount",
        type: "number",
        readOnly: true,
      },
      {
        name: "loan_status",
        label: "Loan Status",
        type: "select",
        options: _enum.APPLICATION_STATUS,
        disabled: true,
      },
      {
        name: "application_status",
        label: "Application Status",
        type: "select",
        options: _enum.APPLICATION_STATUS_ALL,
        disabled: true,
      },
      {
        name: "loan_disbursed_amount",
        label: "Disb. Amount",
        type: "number",
        readOnly: true,
      },
      {
        name: "loan_disbursement_date",
        label: "Disb. Date",
        type: "date",
        // type: "text",
        readOnly: true,
      },
      {
        type: "section",
        label: "Payout Info:",
        divider: true,
        colspan: 24,
        align: "end",
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        type: "empty",
        colspan: 24,
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },

      // PAYOUT INFO FIELDS --------------------------------
      {
        label: "Payment Status",
        name: "connector_payout_status",
        type: "select",
        options: _enum.PAYOUT_STATUS,
        placeholder: "Please Enter",
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_pct",
        label: "Connector Payout %",
        type: "number",
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_amt",
        label: "Connector Payout Amt.",
        type: "text",
        readOnly: true,
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_tds_pct",
        label: "TDS %",
        type: "number",
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_tds_amt",
        label: "TDS Amt.",
        type: "number",
        readOnly: true,
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "net_connector_payout_amt",
        label: "Net Payout Amt",
        type: "number",
        readOnly: true,
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "connector_payout_dtm",
        label: "Payment Date",
        type: "date",
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "bank_payout_pct",
        label: "Bank Payout %",
        type: "number",
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "bank_payout_amt",
        label: "Bank Payout Amt.",
        type: "number",
        required: true,
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "bank_payout_receive_dtm",
        label: "Bank Payout Received Date",
        type: "date",
        dynamicRules: (values) => {
          if (
            values.connector_payout_status === "PROCESSED" ||
            values.connector_payout_status === "PAID"
          ) {
            return [{ required: true, message: "This field is required" }];
          }
          return [];
        },
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
      {
        name: "remarks",
        label: "Remarks",
        type: "textarea",
        colspan: 24,
        showForPersona: [_enum.ROUTE_PERSONAS.admin],
      },
    ],
  };

  const dependencies = {
    // Handle Connector Payout Amount Calculation
    connector_payout_pct: (percent, allValues) => {
      let disbursedAmt = Number(allValues.loan_disbursed_amount);
      let connectorPayoutAmt = (percent / 100) * disbursedAmt;
      return {
        valueUpdates: {
          connector_payout_amt: connectorPayoutAmt,
        },
      };
    },
    // Handle TDS and Payout Amount Calculation
    connector_payout_tds_pct: (tdsPct, allValues) => {
      let tdspct = Number(tdsPct);
      let netPayout, tdsAmount;
      let connectorPayoutAmt = Number(allValues.connector_payout_amt);
      if (tdspct === 0) {
        netPayout = 0;
        tdsAmount = 0;
      } else {
        tdsAmount = (tdspct / 100) * connectorPayoutAmt;
        netPayout = connectorPayoutAmt - connectorPayoutAmt * (tdspct / 100);
      }
      return {
        valueUpdates: {
          connector_payout_tds_amt: tdsAmount,
          net_connector_payout_amt: netPayout,
        },
      };
    },
    // Handle Bank Payout Percentage Calculation
    bank_payout_pct: (bankPayoutPct, allValues) => {
      let bankpct = Number(bankPayoutPct);
      let disbursedAmt = Number(allValues.loan_disbursed_amount);

      let amount = disbursedAmt;
      let percent = bankpct;
      let bankPayoutAmnt = (percent / 100) * amount;
      return {
        valueUpdates: {
          bank_payout_amt: bankPayoutAmnt,
        },
      };
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  const view = (record) => {
    let defaultValues = {
      ...record,
      ...record?.application_payout,
      connector_payout_status: "PROCESSED",
    };
    openModal("payoutInfo", "view", "View Application", defaultValues);
  };

  const edit = (record) => {
    setApplId(record.application_id);
    let defaultValues = {
      ...record,
      ...record?.application_payout,
      connector_payout_status: "PAID",
    };
    openModal("payoutInfo", "edit", "Edit Application", defaultValues);
  };

  const handleAppModalSubmit = async (data) => {
    if (modalState.mode === "edit" && modalState.type === "payoutInfo") {
      let payload = {
        connector_payout_pct: data?.connector_payout_pct,
        connector_payout_amt: data?.connector_payout_amt,
        connector_payout_tds_pct: data?.connector_payout_tds_pct,
        connector_payout_tds_amt: data?.connector_payout_tds_amt,
        net_connector_payout_amt: data?.net_connector_payout_amt,
        connector_payout_status: data?.connector_payout_status,
        connector_payout_dtm: data?.connector_payout_dtm,
        bank_payout_pct: data?.bank_payout_pct,
        bank_payout_amt: data?.bank_payout_amt,
        bank_payout_receive_dtm: data?.bank_payout_receive_dtm,
        remarks: data?.remarks,
      };
      const res = await props.apis.apiAdminUpdateApplicationPayoutInfo(
        payload,
        { application_id: applId }
      );
      if (res) {
        swal2.fire({
          title: "Lead updated successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getData();
      }
    }
  };

  const getData = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, [
        "page",
        "limit",
        "paymentStatus",
      ]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }

    if (!isAdmin) {
      props.apis
        .apiGetApplicationPayoutInfo({
          ...payload,
          // application_status: "SENT",
          connector_payout_status: "PROCESSED",
        })
        .then(({ data, count }) => {
          setData(data);
          setRowcount(count);
          setIsFetching(false);
        });
    } else {
      props.apis
        .apiGetApplicationPayoutInfo({
          ...payload,
          connector_payout_status: "PROCESSED",
        })
        .then(({ data, count }) => {
          setData(data);
          setRowcount(count);
          setIsFetching(false);
        });
    }
  };

  const onSearch = (data, reset) => {
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getData(data, reset);
    }
  };

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };
  // ----------------------------------------------------------------
  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      setNotSelected(false);
    } else {
      setNotSelected(true);
    }
  }, [selectedRowKeys]);

  const handleSendPayment = () => {
    let payload = {
      leadIds: [...selectedRowKeys],
    };

    props.apis.apiSendAdminLeadsForPayment(payload).then((res) => {
      if (res) {
        swal2.fire({
          title: "Leads sucessfully send for payment !!",
          icon: "success",
          iconColor: "#234C9B",
          timer: 4000,
        });
        setSelectedRowKeys([]);
        getData();

        if (res) {
          let url = `${
            props.apis.api().api_base
          }/api/v1/payout/admin/download?digiRepPaidAppIds=${res}`;
          var downloadURL = url;
          var link = document.createElement("a");
          link.setAttribute(
            "download",
            `Leads_Data-${new Date().toLocaleDateString()}.xlsx`
          );
          link.href = downloadURL;
          link.click();
        }
      }
    });
  };
  // ----------------------------------------------------------------

  // ----------------------------------------------------------------
  const bulkUploadModalRef = useRef(0);
  const [popupBulkUploadFields, setPopupBulkUploadFields] = useState({});
  const [popupBulkUploadData, setPopupBulkUploadData] = useState({});
  const [bulkUploadModalFields, setBulkUploadModalFields] = useState([
    {
      label: "File Upload (Max limit 10,000)",
      name: "file",
      type: "filearea",
      accept: ".xlsx, .xls",
      customcolspan: "12",
      required: true,
    },
  ]);

  const downloadTemplateLeads = (e) => {
    // props.apis.apiDownloadBankPayoutTemplate().then((res) => {
    //   console.log({ res });
    //   if (res) {
    //     let url = `${props.apis.api().api_base}/api/v1/bank-payout/template`;
    //     var downloadURL = url;
    //     var link = document.createElement("a");
    //     link.setAttribute(
    //       "download",
    //       `bank_payout_template_${new Date().toLocaleDateString()}.xlsx`
    //     );
    //     link.href = downloadURL;
    //     link.click();
    //   }
    // });
  };

  const downloadBulkLeads = (values) => {
    // let leadIds = tableData?.map((v) => JSON.parse(v.leadId));
    // let payload = {};
    // payload.leads = leadIds;
    // console.log({ downloadBulkLeads: payload });
    // props.apis.apiBulkDownloadLead(payload).then((res) => {
    //   console.log({ res });
    //   // if (res) {
    //   //   let url = `${props.apis.api().api_base}/api/v1/leads/bulk-download`;
    //   //   var downloadURL = url;
    //   //   var link = document.createElement("a");
    //   //   link.setAttribute(
    //   //     "download",
    //   //     `leads_${new Date().toLocaleDateString()}.xlsx`
    //   //   );
    //   //   link.href = downloadURL;
    //   //   // link.target = "_blank";
    //   //   link.click();
    //   // }
    // });
  };
  // ----------------------------------------------------------------
  const downloadExcel = async () => {
    let payload = {
      connector_payout_status: "PROCESSED",
    };
    props.apis.apiExportApplicationPayout(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `Connector_Applications_Details.xlsx`);
        link.click();
      }
    });
  };

  // HANDLE BULK UPLOAD
  const openBulkUploadmodal = () => {
    bulkUploadModalRef.current.click();
  };

  const closeBulkUploadmodal = () => {
    document.querySelector("#bulkUploadModal #bsmodalclose").click();
    setPopupBulkUploadData({});
    setPopupBulkUploadFields({});
  };

  const addBulkUploadModalFields = () => {
    // let fields = (bulkUploadModalFields || []).reduce(
    //   (o, n) => ({ ...o, [n.name]: n }),
    //   {}
    // );
    // let formdata = Object.map(fields, (v, k) => "");
    // // console.log("formdata: ", fields, formdata);
    // setPopupBulkUploadFields(fields);
    // setPopupBulkUploadData(formdata);
    // openBulkUploadmodal();
  };

  const handleBulkUploadSubmit = (e, data, form) => {
    let payload = {
      file: data?.file,
    };

    props.apis.apiBulkUploadBankPayout(payload).then((res) => {
      console.log({ apiBulkUploadBankPayout: res });
      if (res) {
        swal2.fire({
          title: "Bulk Uploaded Successfully.",
          text: `Records Uploaded : ${res?.count || 0}`,
          icon: "success",
          iconColor: "#234C9B",
          timer: 4000,
        });
        closeBulkUploadmodal();
        getData();
      }
    });

    swal2.fire({
      title: "Bulk Uploaded Successfully.",
      //   text: `Records Uploaded : ${res?.count || 0}`,
      icon: "success",
      iconColor: "#234C9B",
      timer: 4000,
    });
    closeBulkUploadmodal();
  };

  // ----------------------------------------------------------------

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      {/* <div className="bulk_download_btn_outer transparent_btns">
        <button
          className="btn btn-sm btn-outline-secondary me-2"
          onClick={(...args) => downloadTemplateLeads(...args)}
        >
          <i className="fa fa-download me-2"></i>
          <span>Download Template</span>
        </button>
        <button
          className="btn btn-sm btn-outline-secondary me-2"
          onClick={(e) => addBulkUploadModalFields(e)}
          ref={bulkUploadModalRef}
          data-bs-toggle="modal"
          data-bs-target="#bulkUploadModal"
        >
          <i className="fa fa-upload me-2"></i>
          <span>Bulk Upload</span>
        </button>
        <button
          className="btn btn-sm btn-outline-secondary me-2"
          onClick={(...args) => downloadBulkLeads(...args)}
          // disabled={disableBulkDownload}
        >
          <i className="fa fa-download me-2"></i>
          <span>Bulk Download</span>
        </button>
      </div> */}
      <ProcessedSearch
        onSearch={(...arg) => onSearch(...arg)}
        downloadTemplateLeads={(...args) => downloadTemplateLeads(...args)}
        addBulkUploadModalFields={(...args) =>
          addBulkUploadModalFields(...args)
        }
        downloadBulkLeads={(...args) => downloadBulkLeads(...args)}
        downloadExcel={(...args) => downloadExcel(...args)}
        bulkUploadModalRef={bulkUploadModalRef}
        isAdmin={isAdmin}
      />
      <AppTable
        data={data}
        columns={columns}
        onChange={(...arg) => onPageChange(...arg)}
        total={rowcount}
        reorder={true}
        viewAction={(...args) => view(...args)}
        deletable={false}
        {...(isAdmin ? { editable: true } : { editable: false })}
        editAction={(e) => edit(e)}
        loading={isFetching}
        // {...(isAdmin
        //   ? {
        //       rowSelection: rowSelection,
        //       checkbox: true,
        //     }
        //   : {})}
      ></AppTable>
      {/* <div
        className={Object.className({
          "row bottom_container": true,
          "d-none": !isAdmin,
        })}
      >
        <div className="col-12 text-end">
          <button
            className={Object.className({
              "btn btn-primary m-4": true,
            })}
            onClick={(e) => handleSendPayment(e)}
            disabled={notSelected}
          >
            Send for Payment
          </button>
        </div>
      </div> */}

      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
        persona={props?.$store?.user?.role}
      />

      <BulkUploadModal
        id="bulkUploadModal"
        modalSize="modal-lg"
        title="Bulk Upload"
        submitText="Upload"
        data={popupBulkUploadData}
        viewmode={false}
        fields={popupBulkUploadFields}
        onSubmit={(...args) => handleBulkUploadSubmit(...args)}
        modaltype="centeredmodal"
        onClose={() => closeBulkUploadmodal()}
      />
    </>
  );
};

export default constore(Processed);
